import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AutenticacaoGuard} from "../../core/guards/autenticacao-guard";
import {TarefaModule} from "./tarefa/tarefa.module";
import {AgendaModule} from "./agenda/agenda.module";

const routes: Routes = [
  {
    path: '',
    loadChildren: () => TarefaModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'agenda',
    loadChildren: () => AgendaModule,
    canActivate: [AutenticacaoGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrabalhoRoutingModule { }
